<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div style="font-family: Montserrat" class="layout--main bg-color" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <vx-tour :steps="steps" v-if="false" :tutorialTypeId="tutorialTypeId" />
    <!-- <vx-tour :steps="steps" v-if="tutorialTypeId == 1" :tutorialTypeId="tutorialTypeId" /> -->


    <!-- <vx-sidebar :sidebarItems="sidebarItems" title="DigiCampus" logo="https://forty5degreesstorage.blob.core.windows.net/user/avatar_Another_Student.png" parent=".layout--main"/> -->

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">

      <div id="content-overlay"></div>

      <div :class="isThemeDark? 'content-wrapper' : 'content-wrapper content-wrapperlight'">

      <!-- <div class="content-wrapper"> -->

        <the-navbar :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]" />

        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <div class="content-area__content">
              <back-to-top bottom="14%" visibleoffset="80" v-if="!hideScrollToTop">
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg back-to-top_btn"
                />
              </back-to-top>
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @data_load_done="data_load_done"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="dashboardbackpack-container" v-show="$route.path == '/menu'">
        <img id="dashboardbackpack-img" @click="openBackpack" src="../../assets/images/backpack.png" class="backpack_btn__navbar mr-3"/>
      </div> -->
      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "../components/vx-sidebar/StudentSidebar.vue";
import TheNavbar from "@/digicampus/components/DigiNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import sidebarItems from "../components/vx-sidebar/sidebarItems.js";
import BackToTop from "vue-backtotop";
const VxTour = () => import('@/components/VxTour.vue');
export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "static",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: sidebarItems,
      windowWidth: window.innerWidth, //width of windows
      hideScrollToTop: themeConfig.hideScrollToTop,
      showBackpack: false,
      steps: [
        {
          target: "#main-navbar-logo",
          content: "Hi! Welcome to the Student Portal. To take a quick tour, click Next...",
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#notificationDropdown",
          content: "Here is where all the notifications live!",
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".chat_btn__navbar",
          content: "Click here to go to your Chats",
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#help-btn-navbar",
          content: "When you need help... click here",
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".the-navbar__user-meta",
          content: "This is where you log out or view your profile",
          params: {
            placement: "bottom",
          },
        },
        {
          target: "#mentoring-btn_menu",
          content: "Go to the Mentoring Menu here",
          params: {
            placement: "top",
          },
        },
      ],
      showTutorial: false,
      tutorialTypeId: null
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      if (val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    }
  },
  methods: {
    data_load_done() {
      var tutorials = this.$getTutorials();

      if (tutorials.includes(1)) {
        this.tutorialTypeId = 1;
      }
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    updateTheme() {
      this.$setColors();
    },
    openBackpack() {
      this.displayBackpack = false,
      this.$router.push({ name: 'BackpackViewer' });
    }
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    BackToTop,
    VxTour
  },
  created() {
    this.$store.dispatch("updateTheme", "dark");
    
    document.title = "DigiCampus";
    this.setSidebarWidth();
    if (this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }

    // this.navbarType = "hidden";

    this.$setSchoolTheme();
    this.updateTheme();
  }
};
</script>
<style lang="scss">

@import "../assets/FabStylesheet_1.scss";
@import "../assets/FabStylesheet_2.scss";

 
  


.vx-navbar-wrapper {
  background: none !important;
  padding: 2.2rem;
  padding-top: 1.3rem;
  z-index: 41000;
  height: 103px;
  position: relative;
  top: 0;
}
.vs-navbar.vx-navbar {
  background: linear-gradient(to bottom right, rgba(var(--vs-primary),1), rgba(var(--vs-secondary),1)) !important;
  padding: .8rem 1rem;
  width: calc(100% - 4.7rem);
  // width: calc(100% - 10.3rem);
  position: fixed;
  border-radius: 2.1rem;
  -webkit-transition: all .5s;
  transition: all .5s;
  z-index: 10000;
}

.router-view {
  // position: absolute !important;
  padding-top: 0 !important;
  padding-inline: 2.2rem ;
  top: 0 !important;
  width: calc(100% - 0rem) !important;

  .router-content {
    margin-top: 0 !important;
    text-align: -webkit-center !important;
    text-align: -moz-center !important;
  }
}

#dashboardbackpack-container {
    position: absolute;
    top: 0;
    right: 1;
    z-index: 0;
    margin-top: 90px;
    margin-left: 30px;
    margin-bottom: 45px;
    margin-right: 20px;

    #dashboardbackpack-img {
      height: 75px;
      fill: white;
      opacity: 0.8;
    }

    #dashboardbackpack-img:hover {
      height: 82px;
      cursor: pointer;
      fill: white;
      opacity: 1;
    }
    #dashboardbackpack-img:active {
      height: 80px;
      cursor: pointer;
      opacity: 0.8;
    }
}

.content-wrapperlight{
  background-color: white !important;
}

</style>
